import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import EstadiaMonitoringPage from 'pages/viagens-controle/estadia-monitoring-page';
import {
  BASE_VIAGENS_CONTROLE_PATH,
  VIAGENS_CONTROLE_ROUTES,
} from 'lib/routes';
import {
  canCreateBilling,
  canListBillings,
  canValidateViagem,
} from 'lib/viagens-controle-permissions';
import {
  ViagensBillingCreatePage,
  ViagensBillingListPage,
  ViagensControleListPage,
} from 'pages/viagens-controle';

const deny = (location: RouterProps['location']) => (
  <Navigate
    to={VIAGENS_CONTROLE_ROUTES.list().url}
    state={{ from: location }}
    replace
  />
);

export const viagensControleRoutes = ({
  isLoggedIn,
  location,
  hasPermissionTo,
  hasAnyPermissionTo = () => false,
}: RouterProps): RouteObject => ({
  path: BASE_VIAGENS_CONTROLE_PATH,
  element:
    isLoggedIn && hasPermissionTo(['ACCESS_VIAGENS_CONTROLE']) ? (
      <Outlet />
    ) : (
      <Navigate to="/" state={{ from: location }} />
    ),
  children: [
    {
      path: VIAGENS_CONTROLE_ROUTES.monitoring().path,
      element: <EstadiaMonitoringPage />,
    },
    {
      path: VIAGENS_CONTROLE_ROUTES.list().path,
      element: <ViagensControleListPage />,
    },
    {
      path: VIAGENS_CONTROLE_ROUTES.approvals().path,
      element: canValidateViagem(hasAnyPermissionTo) ? (
        <ViagensControleListPage approvalMode />
      ) : (
        deny(location)
      ),
    },
    {
      path: VIAGENS_CONTROLE_ROUTES.billings().path,
      element: canListBillings(hasAnyPermissionTo) ? (
        <ViagensBillingListPage />
      ) : (
        deny(location)
      ),
    },
    {
      path: VIAGENS_CONTROLE_ROUTES.createBilling().path,
      element: canCreateBilling(hasAnyPermissionTo) ? (
        <ViagensBillingCreatePage />
      ) : (
        deny(location)
      ),
    },
  ],
});
